import { render, staticRenderFns } from "./verify-otp.vue?vue&type=template&id=243f548f&"
import script from "./verify-otp.vue?vue&type=script&lang=js&"
export * from "./verify-otp.vue?vue&type=script&lang=js&"
import style0 from "./verify-otp.vue?vue&type=style&index=0&id=243f548f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports